import { ArgumentInfra3DSDKError } from "../../error/ArgumentInfra3DSDKError";
export class StateBase {
    constructor(state) {
        this._referenceThreshold = 0.01;
        this._reference = state.reference;
        this._alpha = state.alpha;
        this._currentIndex = state.currentIndex;
        this._trajectory = state.trajectory.slice();
        this._currentNode = this._trajectory.length > 0 ? this._trajectory[this._currentIndex] : null;
        this._previousNode =
            this._trajectory.length > 1 && this.currentIndex > 0 ? this._trajectory[this._currentIndex - 1] : null;
    }
    get reference() {
        return this._reference;
    }
    get alpha() {
        return this._getAlpha();
    }
    get trajectory() {
        return this._trajectory;
    }
    get currentIndex() {
        return this._currentIndex;
    }
    get currentNode() {
        return this._currentNode;
    }
    get previousNode() {
        return this._previousNode;
    }
    setSpeed(speed) {
        /*noop*/
    }
    update(fps) {
        /*noop*/
    }
    append(nodes) {
        if (nodes.length < 1) {
            throw Error("Trajectory can not be empty");
        }
        if (this._currentIndex < 0) {
            this.set(nodes);
        }
        else {
            this._trajectory = this._trajectory.concat(nodes);
        }
    }
    prepend(nodes) {
        if (nodes.length < 1) {
            throw Error("Trajectory can not be empty");
        }
        this._trajectory = nodes.slice().concat(this._trajectory);
        this._currentIndex += nodes.length;
        this._setCurrentNode();
    }
    remove(n) {
        if (n < 0) {
            throw Error("n must be a positive integer");
        }
        if (this._currentIndex - 1 < n) {
            throw Error("Current and previous nodes can not be removed");
        }
        for (let i = 0; i < n; i++) {
            this._trajectory.shift();
            this._currentIndex--;
        }
        this._setCurrentNode();
    }
    clearPrior() {
        if (this._currentIndex > 0) {
            this.remove(this._currentIndex - 1);
        }
    }
    clear() {
        this.cut();
        if (this._currentIndex > 0) {
            this.remove(this._currentIndex - 1);
        }
    }
    cut() {
        while (this._trajectory.length - 1 > this._currentIndex) {
            this._trajectory.pop();
        }
    }
    set(nodes) {
        this._setTrajectory(nodes);
        this._setCurrentNode();
        this._setReference(this._currentNode);
    }
    _getAlpha() {
        return 1;
    }
    _setCurrent() {
        this._setCurrentNode();
    }
    _setReference(node) {
        // do not reset reference if node is within threshold distance
        if (Math.abs(node.latLon.lat - this.reference.lat) < this._referenceThreshold &&
            Math.abs(node.latLon.lon - this.reference.lon) < this._referenceThreshold) {
            return false;
        }
        // do not reset reference if previous node exist and transition is with motion
        if (this._previousNode != null) {
            return false;
        }
        this._reference.lat = node.latLon.lat;
        this._reference.lon = node.latLon.lon;
        this._reference.alt = node.alt;
        return true;
    }
    _setCurrentNode() {
        this._currentNode = this._trajectory.length > 0 ? this._trajectory[this._currentIndex] : null;
        this._previousNode = this._currentIndex > 0 ? this._trajectory[this._currentIndex - 1] : null;
    }
    _setTrajectory(nodes) {
        if (nodes.length < 1) {
            throw new ArgumentInfra3DSDKError("Trajectory can not be empty");
        }
        if (this._currentNode != null) {
            this._trajectory = [this._currentNode].concat(nodes);
            this._currentIndex = 1;
        }
        else {
            this._trajectory = nodes.slice();
            this._currentIndex = 0;
        }
    }
}
//# sourceMappingURL=StateBase.js.map